export default "__VITE_PUBLIC_ASSET__7e6b96f2__"